export const getVisibleSections = (sections, items) => {
  return sections.filter(section => items.some(item => item.section === section.id))
}
